export function groupBy<T extends { [key: string]: any }>(arr: T[], groupByKey: string) {
    const output: { key: string; items: T[] }[] = [];
    arr.forEach((item) => {
        const index = output.findIndex((a) => a.key === item[groupByKey]);
        if (index !== -1) {
            // @ts-ignore
            output[index]["items"].push(item);
        } else {
            output.push({ key: item[groupByKey], items: [item] });
        }
    });
    return output;
}
